import React from 'react';
import './App.css';
import {
  BrowserRouter as Router,
  Switch,
} from 'react-router-dom';
import routes from './routes';
import SiteDown from './SiteDown';
import { Provider } from 'react-redux';
import store from './store';
import { persistor } from './store';
import { PersistGate } from 'redux-persist/integration/react';
import TokenTimeout from './components/TokenTimeout';
import StartupRefresh from './components/StartupRefresh';
import restrictAccess from './lib/restrictAccess';

export default function App() {

  React.useEffect(()=>{
    restrictAccess();
  }, []);

  return (
    <Provider store={store}>
      <SiteDown down={false}>
        <PersistGate loading={<div>Wait</div>} persistor={persistor}>
          <Router>
            <StartupRefresh/>
            <TokenTimeout>
              <Switch>
                {routes}
              </Switch>
            </TokenTimeout>
          </Router>
        </PersistGate>
      </SiteDown>
    </Provider>
  );
}
